export default __webpack_public_path__ + "static/media/amazonses-horizontal.0821a48b.svg";